import { useQuery } from "react-query";
import { getConfieAgreementsCount } from "../../../../actions/CarrierAgreementMgmt/Agreements";

const useConfieAgreementCount = () => {
  return useQuery("GetConfieAgreementCount", getConfieAgreementsCount, {
    refetchOnWindowFocus: false,
  });
};

export default useConfieAgreementCount;
